// extracted by mini-css-extract-plugin
export default {"blockwrapper":"uP","header":"vP","name":"wP","columns":"xP","imagewrapper":"yP","addinfo":"zP","description":"AP","price":"BP","old":"CP","new":"EP","desc_d":"FP","infoblock":"GP","desc_m":"HP"};
    if(module.hot) {
      // 1713211523322
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  